import React from 'react';
import classNames from 'classnames';
import { DateTime } from 'luxon';
import { useInterval } from 'usehooks-ts';
import humanizeDuration from 'humanize-duration';

import { shifts } from './data';

interface Shift {
  start: DateTime;
  end: DateTime;
}

function formatTitle(shift: Shift) {
  const day = shift.start.toFormat('ccc,  LLLL d');
  const start = shift.start.toFormat('h:mm a');
  const end = shift.end.toFormat('h:mm a');
  return `${day} - ${start} to ${end}`;
}

export default function ShiftsList() {
  const [until, setUntil] = React.useState('');

  useInterval(() => {
    const duration = shifts[0].start.diff(DateTime.now());
    setUntil(humanizeDuration(duration.milliseconds, { round: true }));
  }, 500);

  return (
    <div className="m-16 list">
      <table>
        <thead>
          <tr>
            <th>Shifts</th>
            <th>Role</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={2} className="next-shift">
              {`Next shift in ${until}`}
            </td>
          </tr>
          {
            shifts.map((shift) => (
              <tr key={shift.start.toMillis()}>
                <td>
                  <div className="list-label">{formatTitle(shift)}</div>
                  <div className="list-description">{shift.location}</div>
                </td>
                <td>
                  <span className={classNames('badge', { neutral: shift.type === 'On Call' })}>{shift.type}</span>
                </td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </div>
  );
}
